const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29.7,232c-2.2,0-4.3-.9-5.8-2.5-1.5-1.5-2.3-3.6-2.2-5.7,0-2.1.9-4.1,2.5-5.6L224.2,26.2c3.1-3.1,8.2-3,11.2.2,0,0,0,0,0,0,3.1,3.2,3,8.2-.2,11.3,0,0,0,0,0,0L35.3,229.8c-1.5,1.4-3.5,2.2-5.5,2.2Z",
    style: {
      fill: "#f22",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.2,216c-11.5,0-22.9-1.7-33.9-5.1-4.2-1.3-6.6-5.8-5.3-10,1.3-4.2,5.8-6.6,10-5.3h0c9.5,2.9,19.4,4.4,29.4,4.4h2c41.2,0,82.9-29.7,108.2-57.5,3.3-3.7,3.3-9.3,0-13-9.5-10.5-20.1-20-31.6-28.3-3.6-2.6-4.3-7.7-1.7-11.2,1.5-2,3.9-3.2,6.4-3.2,1.7,0,3.3.5,4.7,1.5,12.3,9,23.7,19.2,34,30.5,8.9,9.8,8.9,24.7,0,34.5-27.6,30.4-73.6,62.8-119.9,62.8h-2.4,0Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3,181.5c-1.8,0-3.5-.6-4.9-1.7-10.3-8-19.9-16.9-28.7-26.5-8.9-9.8-8.9-24.7,0-34.5,27.6-30.3,73.6-62.8,119.9-62.8h2.5c9,0,17.9,1.1,26.6,3.3,2.1.5,3.8,1.8,4.9,3.6,2.3,3.8,1.1,8.7-2.7,11-1.8,1.1-4,1.4-6.1.9-7.5-1.8-15.2-2.8-22.9-2.8h-2.5c-41.1,0-82.7,29.7-108,57.5-3.3,3.7-3.3,9.3,0,13,8.2,9,17.1,17.2,26.6,24.6,3.5,2.7,4.1,7.7,1.5,11.2,0,0,0,0,0,0-1.5,2-3.8,3.1-6.3,3.1h0Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,144c-4.4,0-8-3.6-8-8,0-26.5,21.5-48,48-48,4.4,0,8,3.6,8,8s-3.6,8-8,8c-17.7,0-32,14.3-32,32,0,4.4-3.6,8-8,8Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.1,184c-4.4,0-8-3.6-8-8s3.6-8,8-8c8.5,0,16.6-3.4,22.6-9.4,6-6,9.4-14.1,9.4-22.6s3.6-8,8-8,8,3.6,8,8c0,12.7-5,25-14,33.9-9,9-21.2,14.1-33.9,14.1Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewOff);
export default __webpack_public_path__ + "static/media/view-off.11f62081aa93d1ef09464da6bc7b98d1.svg";
export { ForwardRef as ReactComponent };